var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[(_vm.imageUrl)?_c('img',{staticClass:"members-image",attrs:{"src":_vm.imageUrl,"alt":""}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }